import type { ColumnDef } from '@tanstack/react-table';

import type { Equipment } from 'contracts/temperature-control/equipments';
import { EquipmentActionsMenu } from 'pages/TemperatureControl/shared-components';
import { DataTableHelper } from 'utils';

const dt = new DataTableHelper<Equipment>();

export const useEquipmentColumns = (): ColumnDef<Equipment>[] => {
  const id = dt.buildColumn({
    id: 'id',
    title: 'Id',
    accessorKey: 'id',
    size: 10,
    content: row => row.id,
  });

  const equipmentCode = dt.buildColumn({
    id: 'equipmentCode',
    title: 'Cód. equipamento',
    accessorKey: 'equipmentCode',
    content: row => row.equipmentCode,
  });

  const containerCode = dt.buildColumn({
    id: 'containerCode',
    title: 'Cód. container',
    accessorKey: 'containerCode',
    content: row => row.containerCode,
  });

  const branch = dt.buildColumn({
    id: 'companyId',
    title: 'Filial',
    accessorKey: 'companyId',
    content: row => row.company.tradeName,
  });

  const actionsMenu = dt.buildColumn({
    id: 'actionsMenu',
    title: '',
    content: (row) => {
      return (
        <div className={'flex justify-end'}>
          <EquipmentActionsMenu equipment={row} />
        </div>
      );
    },
  });

  return [
    ...(process.env?.NODE_ENV === 'development' ? [id] : []),
    equipmentCode,
    containerCode,
    branch,
    actionsMenu,
  ];
};